import { render, staticRenderFns } from "./areaCourseList.vue?vue&type=template&id=2ae93cf4&"
import script from "./areaCourseList.vue?vue&type=script&lang=js&"
export * from "./areaCourseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports